import React, { useCallback, useEffect, useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import { Typography as CommonsTypography } from '@orijinworks/frontend-commons';
import { getPlaAssignmentHistory } from '../../../../../util/APIUtils';
import StaffLocationHistoryGrid from './staff-location-history-grid';

/**
 * Loads full PLA history for the profile person and renders the DataGrid (filters + built-in loading).
 */
function StaffLocationHistoryTab({ personId, classes, csvExportContext }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    if (personId == null) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    getPlaAssignmentHistory(personId)
      .then((res) => {
        if (res && res.statusCode != null && res.statusCode !== 0) {
          setError(res.statusMessage || 'Request failed');
          setItems([]);
        } else {
          setItems(res?.assignments ?? []);
        }
        setLoading(false);
      })
      .catch((e) => {
        setError(e?.message || 'Failed to load Facility History');
        setItems([]);
        setLoading(false);
      });
  }, [personId]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Box className={classes.plaHistoryRoot}>
      <Box className={classes.sectionHeader}>
        <Box>
          <Typography component="h2" className={classes.sectionHeading}>
            Facility History
          </Typography>
          <Typography className={classes.sectionExplainer}>
            {
              "Chronological record of this user's facility assignments, roles, and active or inactive periods at each location."
            }
          </Typography>
        </Box>
      </Box>
      {error ? (
        <CommonsTypography className={classes.plaHistoryError} variant="body1">
          {error}
        </CommonsTypography>
      ) : (
        <StaffLocationHistoryGrid
          items={Array.isArray(items) ? items : []}
          isLoading={Boolean(loading)}
          classes={classes}
          onRefresh={load}
          csvExportContext={csvExportContext}
        />
      )}
    </Box>
  );
}

export default StaffLocationHistoryTab;
